// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'

import Api from '../Services/SuriApi'

// redux
import CarActions, { CarTypes } from '../Redux/CarRedux'
import GeneralActions from '../Redux/GeneralRedux'

// types

const CarEpic = [
  (action$, state$) =>
    action$.pipe(
      ofType(CarTypes.CAR_INFO_REQUEST),
      switchMap((action) => {
        const verificationCode = state$.value.car.getIn(['data', 'verificationCode'], '')
        let endpoint = 'getCarInfoFromVin'
        switch (action.endpoint) {
          case 'carValuation':
            endpoint = 'getCarIdentificationFromVin'
            break
          case 'windScreen':
            endpoint = 'getCarWindscreenFromVin'
            break
        }
        return from(Api[endpoint](action.vin, `/${verificationCode}`)).pipe(
          switchMap((response) => {
            if (response.status === 200 && response.data.responseType === 'SUCCESS') {
              switch (action.endpoint) {
                case 'carValuation':
                  return from([
                    CarActions.setAutoFinish(action.autoFinish),
                    CarActions.carIdentificationRequestSuccess(response.data.result),
                  ])
                case 'windScreen':
                  return from([
                    CarActions.setAutoFinish(action.autoFinish),
                    CarActions.carWindscreenRequestSuccess(response.data.result),
                  ])
                default:
                  return from([
                    CarActions.carInfoRequestSuccess(response.data.carInfo),
                    CarActions.setAutoFinish(action.autoFinish),
                  ])
              }
            }
            throw response
          }),
          catchError((e) => {
            if (e.response) {
              if (e.response.status === 403) {
                return from([
                  CarActions.setAutoFinish(true),
                  GeneralActions.onChangeRequestFailure('BAD_VERIFICATION_CODE'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              } else if (e.response.status === 429) {
                return from([
                  CarActions.setAutoFinish(true),
                  GeneralActions.onChangeRequestFailure('LIMIT_FOR_PHONE_NUMBER'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              } else if (e.response.status === 404 && e.response.data.responseType === 'VEHICLE_NOT_FOUND') {
                return from([
                  CarActions.setAutoFinish(true),
                  GeneralActions.onChangeRequestFailure('UNKNOWN_VIN'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              } else if (e.response.status === 400 && e.response.data.responseType === 'VIN_MALFORMED') {
                return from([
                  CarActions.setAutoFinish(true),
                  GeneralActions.onChangeRequestFailure('BAD_VIN'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              }
            }
            return from([
              CarActions.setAutoFinish(true),
              GeneralActions.onChangeRequestFailure('CAR_INFO_FAILURE'),
              CarActions.onChangeValue('verificationCode', ''),
            ])
          }),
        )
      }),
    ),
  (action$, state$) =>
    action$.pipe(
      ofType(CarTypes.CAR_VALUATION_REQUEST),
      switchMap((action) => {
        const verificationCode = state$.value.car.getIn(['data', 'verificationCode'], '')
        return from(Api.getCarValuationFromVin(action.data, `/${verificationCode}`, action.accessories)).pipe(
          switchMap((response) => {
            if (response.status === 200 && response.data.responseType === 'SUCCESS') {
              return of(CarActions.carValuationRequestSuccess(action.data.vehicleId, response.data.result))
            }
            throw response
          }),
          catchError((e) => {
            if (e.response) {
              if ([403, 404].includes(e.response.status)) {
                return from([
                  GeneralActions.onChangeRequestFailure('BAD_VERIFICATION_CODE'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              } else if (e.response.status === 429) {
                return from([
                  GeneralActions.onChangeRequestFailure('LIMIT_FOR_PHONE_NUMBER'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              }
            }
            return of(GeneralActions.onChangeRequestFailure('CAR_INFO_FAILURE'))
          }),
        )
      }),
    ),
  (action$) =>
    action$.pipe(
      ofType(CarTypes.VIN_FROM_RZ_REQUEST),
      switchMap((action) =>
        from(Api.getCarVinFromRz(action.rz)).pipe(
          switchMap((response) => {
            if (response.status === 200) {
              return from([
                CarActions.carInfoRequest(
                  response.data.vin,
                  action.autoFinish,
                  action.endpoint,
                  response.data.technicalCardNo,
                ),
                GeneralActions.onStopFetching(),
              ])
            }
            throw response
          }),
          catchError(() => [
            CarActions.setAutoFinish(true),
            GeneralActions.onChangeRequestFailure('VEHICLE_NOT_FOUND')
          ]),
        ),
      ),
    ),
  (action$) =>
    action$.pipe(
      ofType(CarTypes.VERIFICATION_SMS_REQUEST),
      switchMap((action) =>
        from(Api.sendSms(action.phone)).pipe(
          switchMap((response) => {
            if (response.status === 201) {
              return of(CarActions.verificationSmsRequestSuccess())
            }
            throw response
          }),
          catchError((e) => {
            if (e.response) {
              if (e.response.status === 429) {
                return from([
                  GeneralActions.onChangeRequestFailure('LIMIT_FOR_PHONE_NUMBER'),
                  CarActions.onChangeValue('verificationCode', ''),
                ])
              }
            }
            return of(GeneralActions.onChangeRequestFailure('VERIFICATION_SMS_FAILURE'))
          }),
        ),
      ),
    ),
]

export default CarEpic
